// Scroll throttle. When scrolling, it runs no more than once per half second
function checkSTTButton(){

    if ( ! $(this).scrollTop() ) {
        return "hidden";
    }

    if ($(window).scrollTop() + $(window).height() < $(document).height() - $(".footer").height() - $(".stratis").height()) {
        return "fixed";
    } else {
        return "static"
    }

}

$(window).scroll($.throttle(function () {

    var sttButton = document.querySelector('.go-to-top');
    var checkSTT = checkSTTButton();

    // If this class is not setup yet.
    if ( sttButton.className.indexOf(checkSTT) < 0 ) {
        sttButton.className = "go-to-top " + checkSTT;
    }

}, 50));


$(document).ready(function () {
    /*
     * Scroll animation
     */
    $('.go-to-top a[href*="#"]:not([href="#"])').click(function () {
    //$('.go-to-top a').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top + 1
                }, 1000);
                return false;
            }
        }
    });
});
